module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Landing-page-w960.1eca4462.webp";